import { _js } from '@ifixit/utils/localize';
import { faListOl } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext } from '../../editor_context';

export const OrderedListButton = () => {
   const { editor } = useEditorContext();

   if (editor.isDestroyed) {
      return null;
   }

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().toggleOrderedList().run()}
         isActive={editor.isActive('orderedList')}
         isDisabled={!editor.can().toggleOrderedList()}
         icon={<FontAwesomeIcon icon={faListOl} />}
         title={_js('Add a numbered list')}
         shortcut={'shift+7'}
      />
   );
};
